<div class="bulk-actions-container">
  <div>
    <span class="bulk-actions-title">
      Bulk Actions
    </span>
    <span>
      <button class="btn btn-outline-primary" (click)="createBulkAction()">CREATE</button>
    </span>
  </div>
  @if (filterForm) {
    <form [formGroup]="filterForm">
      <div class="bulk-actions-filter-container">
        <input class="form-control" type="search" formControlName="imei"
               placeholder="Search for action containing IMEI.">
      </div>
    </form>
  }
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="bulkActionId">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell class="white-cell" *matCellDef="let bulkAction">
        {{bulkAction.bulkActionId}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell class="white-cell" *matCellDef="let bulkAction">
          {{bulkAction.bulkActionName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="bulkActionType">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell class="white-cell" *matCellDef="let bulkAction">
        {{bulkAction.bulkActionType}}
      </td>
    </ng-container>

    <ng-container matColumnDef="bulkActionStatus">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell class="white-cell" *matCellDef="let bulkAction">
        <div [ngClass]="bulkAction.bulkActionStatus === 'COMPLETED_WITH_ERRORS' ||
                        bulkAction.bulkActionStatus === 'FAILED' ? 'error-status' : ''">
          {{bulkAction.bulkActionStatus}}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdDateTime">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell class="white-cell" *matCellDef="let bulkAction">
        {{bulkAction.createdDateTime}}
      </td>
    </ng-container>

    <ng-container matColumnDef="creatorEmail">
      <th mat-header-cell *matHeaderCellDef>Creator</th>
      <td mat-cell class="white-cell" *matCellDef="let bulkAction">
        {{bulkAction.creatorEmail}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="bulk-action-row" (click)="goToBulkAction(row)"></tr>
  </table>
</div>
